import { render } from "./CreateElement.vue?vue&type=template&id=0b433246&scoped=true"
import script from "./CreateElement.vue?vue&type=script&lang=js"
export * from "./CreateElement.vue?vue&type=script&lang=js"

import "./CreateElement.vue?vue&type=style&index=0&id=0b433246&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b433246"]])

export default __exports__